import Image from "next/image";
import React, { useId } from "react";
import Select, { components } from "react-select";

const SelectShared = ({
  handleChangeSelect,
  name,
  value,
  options,
  isDisabled = false,
  placeholder = "Pilih",
  isImg = false,
  customSelect,
  colorLeft = false,
  customControlClass = "",
  isClearable = false,
}) => {
  const selectUseId = useId();

  const Option = (props) => {
    return isImg ? (
      <components.Option {...props}>
        <div className="option-container">
          {props.data.img && (
            <Image
              src={props.data.img}
              alt={props.data.label}
              className="option-image"
              width={0}
              height={0}
              unoptimized
              priority
              style={{ width: "auto", height: "auto" }}
            />
          )}
          <div className="option-text">
            <div className="option-label">{props.data.label}</div>
            <div className="option-value">{props.data.value}</div>
          </div>
        </div>
      </components.Option>
    ) : customSelect ? (
      <components.Option {...props}>
        {customSelect(props)}
      </components.Option>
    ) : (
      <components.Option {...props}>
        <div className="option-label">{props.data.label}</div>
      </components.Option>
    );
  };

  const Control = ({ children, ...rest }) => {
    return (
      <components.Control {...rest} className={`custom-control ${customControlClass}`}>
        {colorLeft && (
          <div className="color-indicator" style={{ background: rest.getValue()?.[0]?.value }} />
        )}
        {children}
      </components.Control>
    );
  };

  return (
    <div className="select-wrapper">
      <Select
        instanceId={selectUseId}
        components={{ Option, Control }}
        options={options}
        placeholder={placeholder}
        onChange={(e) => handleChangeSelect(e, name)}
        value={options?.filter((d) => d.value === value)}
        isDisabled={isDisabled}
        menuPlacement="auto"
        name={name}
        isClearable={isClearable}
        menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
        menuPosition="fixed"
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
      />
    </div>
  );
};

export default SelectShared;
